import * as filters from '@/packages/array/filter';

export type Filters = 'exact' | 'range';

interface Props {
    children: React.ReactNode;
    conditions: {
        [index: string]: {
            type: Filters;
            value: string;
        };
    };
    criteria: {
        [index: string]: string;
    };
}

export default function Filter({ children, conditions, criteria }: Props): React.JSX.Element {
    let matches = true;

    Object.keys(conditions).forEach((condition) => {
        const type = conditions[condition].type;
        const value = conditions[condition].value;

        if (typeof filters[type] === 'function') {
            matches = matches && filters[type](value, criteria[condition]);
        }
    });

    if (!matches) {
        return <></>;
    }

    return <>{children}</>;
}
